import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../assets/stylesheets/ProfileSlide/ProfileSupport.scss';
import { faChevronLeft, faRedo } from '@fortawesome/free-solid-svg-icons';
import Header from "../Units/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const ProfileSupport = ({ }) => {
    const { t } = useTranslation();
    const dispatch =  useDispatch();
    const [imageCount, setImageCount] = useState(0);
    const [uploadedImage, setUploadedImage] = useState('');
    const [newImageName , setNewImageName] = useState('');

    const increaseImageCount = (imageCount) => {
        return setImageCount(imageCount + 1);
    };

    const addReportImage = (e) =>{
        const reader = new FileReader();
        let fileName = e.target.value.split("\\");
        fileName = fileName[fileName.length - 1].split(".")[0];

        setNewImageName(fileName);
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
            reader.size = formatBytes(e.target.files[0].size, 2);
            reader.name = e.target.files[0].name;
            console.log(reader,e.target.files[0]);
        }
        reader.onload = function (e) {
            setTimeout(() => {
                setUploadedImage(reader);
                increaseImageCount(imageCount);
            }, 500)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    const formatBytes = (bytes) => {
        if(0==bytes)
            return "0 Bytes";
        var c=1024,decimal=2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],
            f=Math.floor(Math.log(bytes)/Math.log(c));
        return parseFloat((bytes/Math.pow(c,f)).toFixed(decimal))+" "+e[f]
    }

    return (
        <div className={`profile-support`}>
            <Header title='supportTitle' backTo={'/profile'} ></Header>
            <div className="mainContainer">
                <div className="messageTitle">
                    {t('youCanWriteYourSuggestions')}
                </div>
                <div className="dialogContent">
                    <div className="reportContainer">
                            <span className="reportText">
                                {t('writeTheReportHere')}
                            </span>
                        <textarea id="mainText" name="mainText">{t('hello')}</textarea>
                    </div>
                    <div className={"reportImageContainer"}>
                        {uploadedImage.result ?
                            (<div className="reportItem">
                                    <div className={'reportImagePreview'} style={{backgroundImage: 'url(' + uploadedImage.result + ')'}}></div>
                                    <div className="textField">
                                        <span>{uploadedImage.name}</span>
                                        <span>{uploadedImage.size}</span>
                                    </div>
                                </div>
                            ) : ''}
                        <div className="reportItem">
                            <input id={"reportImage"} type="file" accept="image/*" onChange={addReportImage} />
                            <div className="textField">
                                <span className="title">Attach file</span>
                                <span>{`${t('max')} 400 MB`}</span>
                                <span>(jpg, png, gif)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="primary">{t('button.send')}</button>
                <div className={'popupButton'}>
                    <span className={`feedbackLabel`}>{t('feedbackHistory')}</span>
                    {/* <Link to={'/tutorial'} className={`tutorialLabel`}>Tutorial</Link> */}
                </div>
            </div>
        </div>
    )
};

export default ProfileSupport;
